export default __webpack_public_path__ + "static/google-play-092b34d7fd90de04be57a394d712cdc8.svg";